// import React, { useEffect, useState } from "react";
// import { Avatar, Divider, Menu, MenuItem } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import message from "../../assets/Header/Message.svg";
// // import axios from "axios";
// import { IoMdNotifications } from "react-icons/io";
// import logoCrazzy from "../../assets/crazzy-hub.png";
// import axiosInstance from "../../config/axios";

// const Header = () => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const navigate = useNavigate();
//   const email = localStorage.getItem("email");
//   const [data, setData] = useState(false);
//   const superuserId = localStorage.getItem("is_superuser");

//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };
//   const handleLogout = () => {
//     navigate("/");
//     localStorage.clear();
//   };
//   // const handleLogoutReseller = () => {
//   //   axios
//   //     .post(
//   //       `https://app1.crazzyhub.com/reseller_app/reseller-log-out/`,
//   //       {
//   //         email: email,
//   //       },
//   //       {
//   //         headers: {
//   //           Authorization: localStorage.getItem("token"),
//   //         },
//   //       }
//   //     )
//   //     .then((response) => {
//   //       localStorage.clear();
//   //       navigate("/");
//   //     })
//   //     .catch((error) => {
//   //       console.log(error);
//   //       toast.error(error.data.message);
//   //     });
//   // };

//   const Logo = () => {
//     axiosInstance
//       .get(
//         `api/admin/multi-vendor-my-profile/`,

//         {
//           headers: {
//             Token: localStorage.getItem("Token"),
//           },
//         },
//       )
//       .then((response) => {
//         setData(response?.data?.data?.profile_data[0]);
//       })
//       .catch((error) => {});
//   };
//   useEffect(() => {
//     Logo();
//   }, []);

//   return (
//     <>
//       <div className="flex flex-row h-16 shadow bg-white border-white sticky top-0">
//         <div
//           className="flex items-center border-b-0 border-r z-50 sticky border-gray-300 "
//           style={{
//             width: "18%",
//             background: "linear-gradient(180deg, #F5A268, #F70000)",
//           }}
//         >
//           <div className="m-5">
//             <img
//               src={logoCrazzy}
//               alt="brandlogo"
//               className="cursor-pointer h-16 p-1"
//             />
//           </div>
//         </div>

//         <div
//           className="flex items-center w-full justify-between text-zinc-700"
//           style={{
//             width: "82%",
//             background: "linear-gradient(180deg, #F5A268, #F70000)",
//           }}
//         >
//           <div className="ml-7">
//             {/* <Search className="!border-none" /> */}
//           </div>

//           <div className="flex items-center justify-center cursor-pointer rounded-md px-3">
//             <div
//               className="flex items-center justify-center !my-2 cursor-pointer rounded-full px-3"
//               style={{
//                 background: "linear-gradient(90deg, #FFA366,#FFC299)",
//               }}
//             >
//               <div className="flex gap-5 mr-5">
//                 {/* <Notifications /> */}
//                 <img src={message} alt="" className="!text-green-500" />
//                 <div
//                   className="w-12 p-1 px-2 flex justify-between rounded-full"
//                   style={{
//                     background: "linear-gradient(135deg, #F261B7, #D05DEA)",
//                   }}
//                 >
//                   <IoMdNotifications className="!text-white" />
//                   <span className="text-white text-[12px]">15</span>
//                 </div>
//               </div>
//               <div className="flex" onClick={handleClick}>
//                 {superuserId === "true" ? (
//                   <Avatar
//                     alt="S"
//                     src="broken.jpg"
//                     className=" !bg-gray-600 p-2"
//                   />
//                 ) : (
//                   <Avatar
//                     alt="A"
//                     src="broken.jpg"
//                     className="!my-2 !h-8 !w-8"
//                     style={{
//                       background: "linear-gradient(180deg, #A1A1DA, #949DED)",
//                     }}
//                   />
//                 )}
//                 <div className="px-2 py-1 text-zinc-700">
//                   {/* <h1 className="font-semibold !text-black">Dashboard</h1> */}
//                   <h1 className="text-xs">
//                     <span className="text-xs !mt-4 text-slate-300 font-bold">
//                       Admin
//                     </span>
//                     <br />
//                     <span className="text-md font-serif">{email}</span>
//                   </h1>
//                 </div>
//               </div>

//               <Menu
//                 anchorEl={anchorEl}
//                 open={open}
//                 onClose={handleClose}
//                 className="!absolute !top-3 !right-40 !shadow-sm"
//                 disableScrollLock
//                 elevation={10}
//               >
//                 <MenuItem
//                   className="hover:!rounded !mx-1"
//                   onClick={() => navigate("/dashboard/profile")}
//                 >
//                   Profile
//                 </MenuItem>
//                 <MenuItem className="hover:!rounded !mx-1">
//                   Account Setting
//                 </MenuItem>
//                 <Divider />
//                 <MenuItem
//                   className="hover:!rounded !mx-1"
//                   onClick={handleLogout}
//                 >
//                   Logout
//                 </MenuItem>
//               </Menu>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;

import React, { useEffect, useState } from "react";
import { Avatar, Divider, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import message from "../../assets/Header/Message.svg";
import { IoMdNotifications } from "react-icons/io";
import logoCrazzy from "../../assets/crazzy-hub.png";
import axiosInstance from "../../config/axios";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const [data, setData] = useState(false);
  const superuserId = localStorage.getItem("is_superuser");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    navigate("/");
    localStorage.clear();
  };

  const Logo = () => {
    axiosInstance
      .get(`api/admin/multi-vendor-my-profile/`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setData(response?.data?.data?.profile_data[0]);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    Logo();
  }, []);

  return (
    <div className="flex h-14 w-full bg-gradient-to-r from-[#F70000] to-[#F5A268] shadow-md">
      {/* Brand area (same width as sidebar) */}
      <div className="flex w-56 shrink-0 items-center px-4">
        <img
          src={logoCrazzy}
          alt="brandlogo"
          className="h-10 w-auto cursor-pointer object-contain"
          onClick={() => navigate("/dashboard")}
        />
      </div>

      {/* Right area */}
      <div className="flex min-w-0 flex-1 items-center justify-end gap-2 px-4">
        {/* Messages */}
        <button
          type="button"
          aria-label="Messages"
          className="flex h-9 w-9 items-center justify-center rounded-full bg-white/20 transition hover:bg-white/35"
        >
          <img src={message} alt="" className="h-5 w-5" />
        </button>

        {/* Notifications */}
        <button
          type="button"
          aria-label="Notifications"
          className="relative flex h-9 w-9 items-center justify-center rounded-full bg-white/20 text-white transition hover:bg-white/35"
        >
          <IoMdNotifications className="text-xl" />
          <span className="absolute -right-1 -top-1 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-[#D05DEA] px-1 text-[10px] font-semibold leading-none text-white ring-2 ring-[#F5A268]">
            15
          </span>
        </button>

        {/* Profile trigger */}
        <button
          type="button"
          onClick={handleClick}
          className="ml-1 flex items-center gap-2 rounded-full bg-white/90 py-1 pl-1 pr-3 shadow-sm transition hover:bg-white"
        >
          {superuserId === "true" ? (
            <Avatar alt="S" className="!h-8 !w-8 !bg-gray-600 !text-sm">
              S
            </Avatar>
          ) : (
            <Avatar
              alt="A"
              className="!h-8 !w-8 !text-sm"
              style={{
                background: "linear-gradient(180deg, #A1A1DA, #949DED)",
              }}
            >
              A
            </Avatar>
          )}

          <span className="hidden min-w-0 text-left leading-tight sm:block">
            <span className="block text-[10px] font-bold uppercase tracking-wide text-zinc-500">
              Admin
            </span>
            <span className="block max-w-[160px] truncate text-xs font-medium text-zinc-800">
              {email}
            </span>
          </span>
        </button>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          disableScrollLock
          elevation={8}
          sx={{ mt: 1 }}
        >
          <MenuItem
            className="!mx-1 !rounded !text-sm"
            onClick={() => navigate("/dashboard/profile")}
          >
            Profile
          </MenuItem>
          <MenuItem className="!mx-1 !rounded !text-sm">
            Account Setting
          </MenuItem>
          <Divider />
          <MenuItem className="!mx-1 !rounded !text-sm" onClick={handleLogout}>
            Logout
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
